//  import { Link } from '@reach/router';
import React, { useState } from 'react';
import { Transition } from '@headlessui/react';
import { useUser } from '../../queries/Accounts';
import { useLogout } from '../../d-man';

export default function ProfileDropdown() {
    const [isOpen, setIsOpen] = useState(false);

    const user = useUser();
    const logout = useLogout();

    const profileName = () => {
        const parts = user?.name.split('.');
        if (parts && parts.length >= 2) {
            return `${parts[0][0].toUpperCase()}${parts[1][0].toUpperCase()}`;
        }

        if (parts && parts.length >= 1) {
            return parts[0][0].toUpperCase();
        }
        return 'U';
    };

    return (
        <>
            <div className="flex flex-row relative">
                <button
                    type="button"
                    className="rounded-full border border-border w-10 h-10 flex justify-center items-center bg-orange-500 transition-opacity hover:opacity-90 focus:outline-none"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <div className="text-white text-sm font-semibold cursor-pointer">
                        {profileName()}
                    </div>
                </button>
                <Transition
                    show={isOpen}
                    enter="transition ease-out duration-100 transform"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="transition ease-in duration-75 transform"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                >
                    {(ref) => (
                        <div
                            ref={ref}
                            className="origin-top-right absolute right-0 top-12 w-40 rounded-lg border border-border shadow-lg bg-surface"
                        >
                            <div
                                className="py-1"
                                role="menu"
                                aria-orientation="vertical"
                                aria-labelledby="options-menu"
                            >
                                {/*  <div
                                className="block w-full text-left px-4 py-2 text-sm text-label hover:bg-surface-muted hover:text-foreground"
                                role="menuitem"
                            >
                                <Link to="/profile">Profile</Link>
                            </div>  */}
                                <button
                                    className="block w-full text-left px-4 py-2 text-sm text-label hover:bg-surface-muted hover:text-foreground focus:outline-none focus:bg-surface-muted focus:text-foreground"
                                    role="menuitem"
                                    onClick={() => logout()}
                                    type="button"
                                >
                                    Log Out
                                </button>
                            </div>
                        </div>
                    )}
                </Transition>
            </div>
        </>
    );
}
